import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import * as api from './api';
import * as types from './types';

export const fetchUsers = createAsyncThunk('filterBar/fetchUsers', async (params: api.GetUsersParams) => {
  const response = await api.getUsers(params);
  return response.data;
});

export const fetchTeams = createAsyncThunk('filterBar/fetchTeams', async (params: api.GetTeamsParams) => {
  const response = await api.getTeams(params);
  return response.data;
});

export const fetchFilters = createAsyncThunk('filterBar/fetchFilters', async (params: api.GetFiltersParams, { signal }) => {
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });

  const response = await api.filtersSearch({
    params,
    cancelToken: source.token,
  });
  return response.data;
});

export const fetchUser = createAsyncThunk('filterBar/fetchUser', async (params: { id: string }) => {
  const response = await api.getUser(params);
  return response.data;
});

export const fetchTeam = createAsyncThunk('filterBar/fetchTeam', async (params: { id: string }) => {
  const response = await api.getTeam(params);
  return response.data;
});

export const searchByField = createAsyncThunk('filterBar/searchByField', async (params: api.SearchByFieldParams) => {
  const response = await api.searchByField(params);
  return response.data;
});

export const addBuild = createAction<types.EnvironmentScopedPayload<string[]>>('filterBar/addBuild');
